module.exports = __webpack_public_path__ + "static/frame-mock.ed257d2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/frame-mock.png
// module id = 1183
// module chunks = 81679748166845